module.exports = __webpack_public_path__ + "img/crown.b32ea486.svg";